import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './ui/Section';
export function Guarantee() {
  return <Section variant="alt" className="!py-12 md:!py-16" data-id="element-75" data-mp="1o2vigsgkwt85">
      <div className="max-w-xl mx-auto bg-white border border-brand-border rounded-3xl p-7 md:p-10 text-center shadow-card" data-id="element-76" data-mp="2236a3xppqbud">
        <div className="w-12 h-12 rounded-full bg-brand-primaryLight flex items-center justify-center mx-auto mb-4" data-id="element-77" data-mp="1x5d4b5sbnjum">
          <ShieldCheckIcon className="w-6 h-6 text-brand-primary" data-id="element-78" data-mp="19fipwjsctn89" />
        </div>
        <h2 className="font-display text-xl md:text-2xl font-bold text-brand-title mb-3" data-id="element-79" data-mp="14gpdyvspu4a7">
          Garantía total de 30 días
        </h2>
        <p className="font-body text-brand-text text-sm md:text-base leading-relaxed" data-id="element-80" data-mp="1j6n6tp1lbi5q">
          Aplica el sistema durante 21 días. Si no has notado una diferencia
          real en tu hinchazón, tu energía y tu relación con la comida,
          escríbenos y te devolvemos el 100% de tu inversión en menos de 48
          horas.{' '}
          <span className="text-brand-primary font-semibold" data-id="element-81" data-mp="ozrmu7gdw7y8">
            Sin preguntas. Sin formularios. Sin esperas.
          </span>
        </p>
      </div>
    </Section>;
}